<table class="table table-striped table-responsive">
  <caption></caption>
  <thead class="table-head">
    <tr>
      <th [attr.colspan]="answersIndex" class="table-th">
        {{formTitle}}
        <app-audioplayer *ngIf="formItem?.item?.allowAudio && formItem?.item?.audioFileName != '' && formItem.item?.audioFileName != null " [formItem]="formItem" [formId]="formId"></app-audioplayer>
      </th>
      <ng-container class="ng-container" >
        <th *ngFor="let label of optionsLabelArray" class="options-label">
          {{label}}
        </th>
      </ng-container>
    </tr>
  </thead>
  <label [attr.colspan]="answersIndex" class="responsive-title">
    {{formTitle}}
    <app-audioplayer *ngIf="formItem?.item?.allowAudio && formItem?.item?.audioFileName != '' && formItem.item?.audioFileName != null " [formItem]="formItem" [formId]="formId"></app-audioplayer>
  </label>
  <tbody>
    <tr *ngFor="let option of options; let i = index;">
      <th [ngClass]="{'required': (option.item.isRequired && !option.value)}" [attr.colspan]="answersIndex">
        {{option.item.labelField}}
      </th>
      <ng-container>
        <td *ngFor="let valueOption of radioOptions;let j = index;" [attr.data-label]="optionsLabelArray[j]">
          <label class="custom-control custom-radio">
            <input [id]="formItem.id + '-' + valueOption.keydsi"  [name]="option.id" [(ngModel)]="formItem.formListInstanceItem[i].value" (change)="updateConditional(option)" [value]="valueOption.keydsi"
              type="radio" class="custom-control-input">
            <i class="bi bi-circle"></i><i class="bi bi-record-circle"></i>
          </label>
        </td>
      </ng-container>
    </tr>
  </tbody>
</table>
